const initAnchorPositioningPolyfill = () => {
	// Hide from compliant browsers
	if (!('anchorName' in document.documentElement.style)) {
		import('@oddbird/css-anchor-positioning')
			.then(module => {
				const executePolyfill = module.default;
				if (typeof executePolyfill === 'function') {
					executePolyfill();
				}
			})
			.catch(() => {
				return false;
			});
	}
};

export default initAnchorPositioningPolyfill;
